import Axios from 'axios'

let connectionLostCount = 0

async function getMeterDataFromBackend({ commit, state, dispatch }) {
  try {
    let getParameters = {
      //'efToken': state.authentication.backendAccessToken,
      ownCubeName: state.cube.name,
    }
    const url = state.urls.backend + '/meterData/getCurrentRead'
    const result = await Axios.get(url, {
      params: getParameters,
      headers: {
        efToken: state.authentication.backendAccessToken,
      },
    })

    commit('meterDataReceived', result.data.data)
  } catch (err) {
    dispatch('logError', 'Requesting meterdata failed: ' + err)
  }
}

function setDotIndex({ commit }, value) {
  commit('setDotIndex', value)
}

function updateDotPositions({ commit }, coordinates) {
  commit('dotPositionsUpdated', coordinates)
}

function cubeConnectionLost({ commit, dispatch, state }) {
  if (state.currentReads.backendMeterDataInterval) {
    // Don't set multiple intervals.
    return
  }

  dispatch('getMeterDataFromBackend')

  connectionLostCount++
  const interval = setInterval(() => {
    dispatch('getMeterDataFromBackend')
  }, state.currentReads.backendMeterDataIntervalDuration)

  if (connectionLostCount > 2) {
    commit('onCubeConnectionLost', interval)
  }
}

function cubeConnectionEstablished({ state }) {
  // The connection to the cube was just established.
  // Clear the polling interval to the backend.
  if (state.currentReads.backendMeterDataInterval) {
    clearInterval(state.currentReads.backendMeterDataInterval)
  }
  connectionLostCount = 0
  state.currentReads.isCubeReachable = true
}

export default {
  setDotIndex,
  getMeterDataFromBackend,
  updateDotPositions,
  cubeConnectionEstablished,
  cubeConnectionLost,
}
